import { Button as MantineButton } from '@mantine/core'
import { cnb } from 'cnbuilder'

import type { ButtonProps } from '@/components/Button/Button.types'

import classes from './Button.module.css'

export function Button({ variant = 'primary', ...props }: ButtonProps) {
  return (
    <MantineButton
      className={cnb(classes.button, classes[variant])}
      loaderProps={{ type: 'dots' }}
      {...props}
    />
  )
}
